import styles from "../../pages/styles.module.css";

const radioButton = styles.radioButton;
const selectedutton = styles.selected;

export const RadioButton = ({
  label = "",
  lng = "",
  selected = false,
  logo = "",
  onSelect = () => {},
}) => (
  <button className={selected ? selectedutton : radioButton} onClick={onSelect}>
    {logo.length > 0 && <img src={logo} alt="logo" width={90} />}
    <p className={styles.courseName}>{label}</p>
  </button>
);
